<template>
    <v-container app :fluid="true">
        <v-row>
            <v-col cols="10" class="pt-0 pb-0">
                <template>
                    <v-container>
                        <v-row>
                            <v-col cols="12" class="pt-0 pl-0">
                                <filter-debt></filter-debt>
                            </v-col>                            
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="pt-0">
                                <div class="content-list-debts wost-scroll">
                                    <card-debt></card-debt>
                                </div>                                
                            </v-col>                            
                        </v-row>
                    </v-container>
                </template>                
            </v-col>
            <v-col cols="2">
                <summary-debt></summary-debt>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import CardDebt from '../../components/debts/CardDebt'
import FilterDebt from '../../components/debts/FilterDebt'
import SummaryDebt from '../../components/debts/SummaryDebt'

export default {
    name: 'Debts',
    components: {
        CardDebt,
        FilterDebt,
        SummaryDebt
    },
    computed: {
        ...mapState('cash', [
            'cashCurrent'
        ])
    },
    methods: {
        ...mapActions('cash', [
            'getCashCurrent'
        ])
    },
    created () {
        this.getCashCurrent();
    }
}
</script>

<style>
.content-list-debts{
    height: 72vh;
    overflow-y: auto;
}
</style>